import { InsuranceDto } from '@maia/shared';
import {
  cardStyles,
  ResourceEmptyState,
  SectionWithHeader,
  SpecList,
  Typography,
} from '@maia/ui';
import { twMerge } from 'tailwind-merge';

type Props = {
  insurance: InsuranceDto;
};

export function CoveragesInformationCard(props: Props) {
  const { insurance } = props;

  return (
    <>
      <Typography
        variant="body-m"
        weight="medium"
        className="inline-block mb-16"
      >
        Dekkingen
      </Typography>
      <div className="flex flex-col gap-y-24">
        {insurance.coverages.map((coverage) => (
          <SectionWithHeader title={coverage.title} key={coverage.guid}>
            {coverage.specs.length &&
            coverage.specs.some((spec) => !!spec.value) ? (
              <div
                className={twMerge(cardStyles({ variant: 'outlined' }), 'p-20')}
              >
                <SpecList
                  items={coverage.specs.flatMap((spec) => {
                    if (!spec.value) {
                      return [];
                    }
                    return {
                      title: spec.label,
                      value: spec.value,
                      isHalf: true,
                    };
                  })}
                />
              </div>
            ) : (
              <ResourceEmptyState
                message={`${coverage.title} heeft geen specificaties.`}
              />
            )}
          </SectionWithHeader>
        ))}
      </div>
    </>
  );
}
